import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=60bda8e7&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=ts&"
export * from "./NoData.vue?vue&type=script&lang=ts&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=60bda8e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bda8e7",
  null
  
)

export default component.exports